import React from 'react';
import { Button, List, Popover, Row, Col } from 'antd';

/**
 * Price Component
 * @param item
 * @param jpy
 * @returns {*}
 * @constructor
 */
export const Price = ({ item, jpy }) => (
  <div>
    <div className='font-weight-bold fs-xs text-right mb-0'>
      <span className='mr-1'>豪ドル</span>
      <span className='text-success h3 font-weight-bold ml-1'>${item.get('lowest')}</span>
    </div>
    {jpy &&
      <div className='font-weight-bold fs-xs text-right mb-0'>
        {item.get('price') &&
          <span className='dimio-jpy'> (約{parseInt(item.get('price')) * parseInt(jpy)}円)</span>
        }
      </div>
    }
  </div>
);

export const Plans = ({ item }) => {
  const ret = [];
  if (item.get('prices')) {
    item.get('prices').forEach(plan => {
      ret.push(
        <div>
          <Row className=''>
            <Col sm={24}>
              <div className='font-weight-bold fs-xs my-0'>{plan.get('name')}</div>
            </Col>
            <Col sm={24}>
              <div className='font-weight-bold text-right mb-0'>
                <span className='mr-1 fs-xs'>豪ドル</span>
                <span className='text-success h4 font-weight-bold ml-1'>${plan.get('adult')}</span>
              </div>
            </Col>
          </Row>
          <hr className="mt-2 mb-2" />
        </div>
      );
    });
  }

  return ret;
};


/**
 * List/Card Item Component
 * @param item
 * @param jpy
 * @returns {*}
 * @constructor
 */
export const Item = ({ item, jpy }) => (
  <a className='card card-travel mb-4' href={item.get('url')}>
    {item.get('sale') &&
      <img className='card-travel__label'
        src='https://tora-tora.net/js/Bootstrap4-alpha6/dev/images/icon/sale.svg' alt='' />
    }

    <Row type='flex' gutter={8}>
      <Col xs={8} md={24}>
        {item.get('thumb') &&
          <img className='card-travel__img border-1 rounded mb-2' src={item.get('thumb')} alt={item.get('name')} />
        }
      </Col>
      <Col xs={16} md={24}>
        <div className='fs-xs text-primary'>{item.get('city_name')}</div>
        <h3 className='card-travel__title mb-0'>{item.get('name')}</h3>
        <hr />
        <Row type="flex" justify="space-between" align="middle">
          <Col>
            <Popover placement="bottom" title='プラン' content={<Plans item={item} />} trigger="click">
              <Button type="default" size="small" className="card-travel__btn">プランを見る</Button>
            </Popover>
          </Col>
          <Col>
            <Price item={item} jpy={jpy} />
          </Col>
        </Row>
      </Col>
    </Row>
  </a>
);



// WEBPACK FOOTER //
// ./src/pages/search/components/Library.js